import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactForm from "../../components/ContactFrom/ContactForm";
import { useLanguage } from "../../context/LanguageContext";

// import background image
import contactBg from "../../images/bg/contact-bg02.png";

const ContactPage: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    document.title = `${t.nav.contact} | ${t.company.name}`;
  }, [t.nav.contact, t.company.name]);

  const contactChannels = [
    {
      icon: "fas fa-envelope-open-text",
      title: "Email Korporat",
      value: t.company.email,
      href: `mailto:${t.company.email}`,
      subtitle: "Respon dalam 1x24 jam kerja",
    },
    {
      icon: "fas fa-phone-volume",
      title: "Telepon Kantor",
      value: t.company.phone,
      href: `tel:${t.company.phone.replace(/[^0-9+]/g, "")}`,
      subtitle: "Senin - Jumat (09:00 - 18:00 WIB)",
    },
    {
      icon: "fab fa-whatsapp",
      title: "WhatsApp Konsultasi",
      value: t.company.whatsapp,
      href: `https://wa.me/${t.company.whatsapp.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(
        "Halo PT Prima Cipta Artifisial, saya ingin konsultasi mengenai solusi integrasi AI untuk perusahaan saya."
      )}`,
      subtitle: "Respon cepat tim arsitek AI",
      isHighlight: true,
    },
    {
      icon: "fas fa-map-marker-alt",
      title: "Alamat Kantor",
      value: t.company.address,
      href: "https://maps.google.com/?q=TB+Simatupang+Cilandak+Jakarta+Selatan",
      subtitle: "Head Office - Jakarta Selatan",
    },
  ];

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={t.nav.contact} pagesub={t.nav.contact} />

            {/* Quick Contact Cards */}
            <div className="container mt-60 mb-60">
              <div className="row g-4">
                {/* {contactChannels.map((item, idx) => (
                  <div className="col-lg-3 col-md-6" key={idx}>
                    <a
                      href={item.href}
                      target={item.href.startsWith("http") ? "_blank" : undefined}
                      rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      style={{
                        display: "block",
                        padding: "26px 22px",
                        borderRadius: "18px",
                        backgroundColor: item.isHighlight
                          ? "rgba(0, 255, 151, 0.08)"
                          : "rgba(255, 255, 255, 0.03)",
                        border: item.isHighlight
                          ? "1px solid rgba(0, 255, 151, 0.4)"
                          : "1px solid rgba(255, 255, 255, 0.08)",
                        backdropFilter: "blur(16px)",
                        textDecoration: "none",
                        transition: "all 0.3s ease",
                        height: "100%",
                      }}
                      className="contact-card-hover"
                    >
                      <div
                        style={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "12px",
                          backgroundColor: item.isHighlight ? "#00FF97" : "rgba(0, 255, 151, 0.15)",
                          color: item.isHighlight ? "#000" : "#00FF97",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "20px",
                          marginBottom: "16px",
                        }}
                      >
                        <i className={item.icon}></i>
                      </div>
                      <div
                        style={{
                          color: "rgba(255, 255, 255, 0.55)",
                          fontSize: "12px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          marginBottom: "4px",
                        }}
                      >
                        {item.title}
                      </div>
                      <div
                        style={{
                          color: "#ffffff",
                          fontSize: "14.5px",
                          fontWeight: 600,
                          lineHeight: "1.4",
                          marginBottom: "6px",
                          wordBreak: "break-word",
                        }}
                      >
                        {item.value}
                      </div>
                      <div
                        style={{
                          color: "#00FF97",
                          fontSize: "11.5px",
                        }}
                      >
                        {item.subtitle}
                      </div>
                    </a>
                  </div>
                ))} */}
              </div>
            </div>

            {/* Contact Form and Map */}
            <section className="contact pb-120">
              <div className="container">
                <div
                  className="xb-contact-wrap xb-border bg_img"
                  style={{
                    backgroundImage: `url(${contactBg})`,
                  }}
                >
                  <div className="xb-contact-form xb-main-contact xb-border">
                    <div className="form-heading text-center mb-30">
                      <h3 className="title">{t.contact.formTitle}</h3>
                      <p className="sub-title clr-white">
                        {t.contact.formSubtitle}
                      </p>
                    </div>

                    <ContactForm />
                  </div>

                  {/* Google Map Embed (Jakarta Selatan) */}
                  <div className="google-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8975.279315200649!2d106.8253903!3d-6.2556569!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3d2f4f30707%3A0xc7b90adf8975cb0f!2sFancy%20Home%20Interior!5e1!3m2!1sid!2sid!4v1786877646611!5m2!1sid!2sid"
                      loading="lazy"
                      title="PT Prima Cipta Artifisial Office Map"
                      referrerPolicy="no-referrer-when-downgrade"
                      style={{ width: "100%", height: "100%", border: 0 }}
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;